import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IConsultarEstatisticaState } from './types';

export const INITIAL_STATE: IConsultarEstatisticaState = {
	status: 0,
	data: null,
	totalRegistrosConsulta: 0,
	previousRequest: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): IConsultarEstatisticaState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_ESTATISTICA_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.previousRequest = action.payload;
				break;
			}
			case Types.CONSULTAR_ESTATISTICA_SUCCESS: {
				draft.totalRegistrosConsulta =
					action.payload.headers['x-num-registros'];
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_ESTATISTICA_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CONSULTAR_ESTATISTICA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				draft.previousRequest = INITIAL_STATE.previousRequest;
				break;
			}

			default:
		}
		return draft;
	});
}
